import { render, staticRenderFns } from "./MessageAlert.vue?vue&type=template&id=27bb8344&scoped=true&"
import script from "./MessageAlert.vue?vue&type=script&lang=js&"
export * from "./MessageAlert.vue?vue&type=script&lang=js&"
import style0 from "./MessageAlert.vue?vue&type=style&index=0&id=27bb8344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bb8344",
  null
  
)

export default component.exports